import React, {useEffect, useState } from "react";
import { toast } from 'react-toastify';
import { InputGroup, RadioButtonInputGroup, RadioSwitch } from "@sb1/ffe-form-react";
import Dropdown from "@sb1/ffe-dropdown-react";
import { ActionButton} from "@sb1/ffe-buttons-react";
import { useAxios } from '../../../AxiosHandler';
import { useNavigate } from "react-router-dom";

import styles from './Loanform.module.scss';
import InputWithUsability from "../../Shared/InputWithUsability/InputWithUsability";
import ContentCard from "../../Shared/ContentCard/ContentCard";
import { useTranslate } from "react-polyglot";
import Header from "../../Shared/Header/Header";

function Loanform() {
    const axiosHandler = useAxios();
    const axios = axiosHandler.axios;
    const navigate = useNavigate();
    const t = useTranslate();

    // get form id from url
    const guid = window.location.pathname.split("/")[2];

    const [loading, setLoading] = useState<boolean>(true);
    const [notFound, setNotFound] = useState<boolean>(false);

    const [formdata, setFormdata] = useState<any>({});

    const [showMoreElectronicCommunication, setShowMoreElectronicCommunication] = useState<boolean>(false);
    const [showMoreShareInformation, setShowMoreShareInformation] = useState<boolean>(false);
    
    const [housing, setHousing] = useState<number>(0);
    const [coHousing, setCoHousing] = useState<number>(0);
    const [pep, setPep] = useState<boolean>();
    const [coPep, setCoPep] = useState<boolean>();
    const [salary, setSalary] = useState<number>();
    const [coSalary, setCoSalary] = useState<number>();
    const [debt, setDebt] = useState<number>();
    const [coDebt, setCoDebt] = useState<number>();
    const [houseIncome, setHouseIncome] = useState<number>();
    const [houseDebt, setHouseDebt] = useState<number>();
    const [rent, setRent] = useState<number>();
    const [coRent, setCoRent] = useState<number>();
    const [kids, setKids] = useState<number>();
    const [coKids, setCoKids] = useState<number>();
    const [domestic, setDomestic] = useState<number>(0);
    const [coDomestic, setCoDomestic] = useState<number>(0);
    const [feedbackMessages, setFeedbackMessages] = useState<Array<string>>([]);
    const [showFeedback, setShowFeedback] = useState<boolean>(false);

    const [beenActived, setBeenActived] = useState<Array<string>>([]);

    const [shareInformation, setShareInformation] = useState<string>();
    const [electronicCommunication, setElectronicCommunication] = useState<string>();

    const [invalid, setInvalid] = useState<boolean>();

    function getForminfo() {
        axios.single({
            url: '/api/loanform/' + guid,
            method: 'GET',
            headers: {
                "Content-Type": "application/json"
            }
        }).then((res: any) => {
            setLoading(false);
            setFormdata(res.data);
        }).catch((err: any) => {
            console.log(err);
            setNotFound(true);
            setLoading(false);
        });
    }

    function sendInformation() {
        toast.info("Sender opplysninger...", { autoClose: false });
        axios.single({
            url: '/api/loanform/' + guid,
            method: 'POST',
            headers: {
                "Content-Type": "application/json"
            },
            data:   [
                {
                    "AnswerValue" : formdata.IsCoBuyer ? coPep?.toString() : pep?.toString(),
                    "DataType" : "bool",
                    "PreviewCode" : 21
                },
                {
                    "AnswerValue" : formdata.IsCoBuyer ? coSalary?.toString() : salary?.toString(),
                    "DataType" : "real",
                    "PreviewCode" : 9
                },
                {
                    "AnswerValue" : formdata.IsCoBuyer ? coKids?.toString() : kids?.toString(),
                    "DataType" : "real",
                    "PreviewCode" : 99
                },
                {
                    "AnswerValue" : formdata.IsCoBuyer ? coDebt?.toString() : debt?.toString(),
                    "DataType" : "real",
                    "PreviewCode" : 10
                },
                housing == 1012 || coHousing == 1012 ?
                {
                    "AnswerValue" : formdata.IsCoBuyer ? coRent?.toString() : rent?.toString(),
                    "DataType" : "real",
                    "PreviewCode" : 1009
                }: undefined,
                {
                    "AnswerValue" : formdata.IsCoBuyer ? coDomestic?.toString() : domestic?.toString(),
                    "DataType" : "dict",
                    "PreviewCode" : 102,
                },
                {
                    "AnswerValue" : formdata.IsCoBuyer ? coHousing?.toString() : housing?.toString(),
                    "DataType" : "dict",
                    "PreviewCode" : 101
                },
                !formdata.IsCoBuyer && domestic == 1021 ? {
                    "AnswerValue" : houseIncome?.toString(),
                    "DataType" : "real",
                    "PreviewCode" : 1007
                } : undefined,
                !formdata.IsCoBuyer && domestic == 1021 ? {
                    "AnswerValue" : houseDebt?.toString(),
                    "DataType" : "real",
                    "PreviewCode" : 1008
                } : undefined,
                !formdata.IsCoBuyer ? {
                    "AnswerValue" : shareInformation?.toString(),
                    "DataType" : "dict",
                    "PreviewCode" : 607
                } : undefined,
                !formdata.IsCoBuyer ? {
                    "AnswerValue" : electronicCommunication?.toString(),
                    "DataType" : "dict",
                    "PreviewCode" : 617
                } : undefined
              ].filter(i => i != undefined)
        }).then((res: any) => {
            toast.dismiss();
            if (res.status == 200) {
                toast.success("Dine opplysninger er sendt.");
                navigate('/loanform/' + guid + '/success');
            }
        }).catch((err: any) => {
            toast.dismiss();
            console.log(err);
            toast.error("Noe gikk galt, prøv igjen.");
        });
    }

    function isNumberInputValid(visible: boolean, value: any, checkvalue: number, feedback: string) {
        if (!visible) return undefined;
        if (value != undefined && value < checkvalue) return feedback;
        if (value == undefined) return feedback;
        return undefined;
    }

    function isDropdownInputValid(visible: boolean, value: any, checkvalue: number, feedback: string) {
        if (!visible) return undefined;
        if (value == checkvalue) return feedback;
        return undefined;
    }

    function isBooleanInputValid(visible: boolean, value: any, checkvalue: boolean|undefined, feedback: string) {
        if (!visible) return undefined;
        if (value == checkvalue) return feedback;
        return undefined;
    }

    function isFormValid () {
        Promise.all ([
            isBooleanInputValid(!formdata.IsCoBuyer, pep, undefined, "Du må velge om du er politisk eksponert person"),
            isNumberInputValid(!formdata.IsCoBuyer, salary, 0, "Du må oppgi en årsinntekt på 0 eller høyere"),
            isNumberInputValid(!formdata.IsCoBuyer, debt, 0, "Du må oppgi en gjeld på 0 eller høyere"),
            isNumberInputValid(!formdata.IsCoBuyer && domestic == 1021, houseIncome, 0, "Du må oppgi husstandens årsinntekt som 0 eller høyere"),
            isNumberInputValid(!formdata.IsCoBuyer && domestic == 1021, houseDebt, 0, "Du må oppgi husstandens gjeld som 0 eller høyere"),
            isNumberInputValid(!formdata.IsCoBuyer && housing == 1012, rent, 0, "Du må oppgi en månedlig leie på 0 eller høyere"),
            isNumberInputValid(!formdata.IsCoBuyer, kids, 0, "Du må oppgi antall barn på 0 eller høyere"),
            isDropdownInputValid(!formdata.IsCoBuyer, domestic, 0, "Du må velge sivilstatus"),
            isDropdownInputValid(!formdata.IsCoBuyer, housing, 0, "Du må velge boforhold"),
            isDropdownInputValid(!formdata.IsCoBuyer, shareInformation, 0, "Du må velge om Sparebank1 skal kunne forstå hva du trenger"),
            isDropdownInputValid(!formdata.IsCoBuyer, electronicCommunication, 0, "Du må velge om du samtykker til elektronisk kommunikasjon fra SpareBank 1 for råd og tilbud"),
            isBooleanInputValid(formdata.IsCoBuyer, coPep, undefined, "Du må velge om samskyldner er politisk eksponert person"),
            isNumberInputValid(formdata.IsCoBuyer, coSalary, 0, "Samskyldner må oppgi en årsinntekt på 0 eller høyere"),
            isNumberInputValid(formdata.IsCoBuyer, coDebt, 0, "Samskyldner må oppgi en gjeld på 0 eller høyer"),
            isNumberInputValid(formdata.IsCoBuyer && coHousing == 1012, coRent, 0, "Samskyldner må oppgi en månedlig leie på 0 eller høyere"),
            isDropdownInputValid(formdata.IsCoBuyer, coDomestic, 0, "Samskyldner må velge sivilstatus"),
            isDropdownInputValid(formdata.IsCoBuyer, coHousing, 0, "Samskyldner må velge boforhold"),
        ]).then ((values) => {
            setFeedbackMessages(values.filter((value) => value != undefined) as Array<string>);
            values.every((value) => value == undefined) ? setInvalid(false) : setInvalid(true);
        }).catch((err) => {
            console.log(err);
        });
    }

    useEffect(() => {
        isFormValid();
    }, [pep,
        salary, 
        debt, 
        rent, 
        kids, 
        domestic, 
        housing,
        houseIncome,
        houseDebt,
        shareInformation,
        electronicCommunication,
        coPep,
        coSalary,
        coDebt,
        coRent,
        coDomestic,
        coHousing
    ]);

    useEffect(() => {
        if (guid != undefined) {
            getForminfo();
        }
    }, [guid]);

    return (<>
        <Header />
        { !loading ? 
            <div className={styles.loanform}>
                { !notFound || guid == "test" ?
                <>
                    {formdata.IsCoBuyer ? null :
                        <ContentCard open={true} disableClick={true}>
                            <h1>{t("loanform.additionalinfo.title")}</h1>
                            <RadioButtonInputGroup
                                label={t("loanform.additionalinfo.fields.pep.label")}
                                description={t("loanform.additionalinfo.fields.pep.description")}
                                fieldMessage={beenActived.includes("pep") && isBooleanInputValid(true, pep, undefined, t("loanform.additionalinfo.fields.pep.invalid"))}
                                name="pep"
                                onBlur={() => setBeenActived([...beenActived, "pep"])}
                                selectedValue={pep?.toString()}
                                onChange={e => {
                                    setPep(e.target.value == "true");
                                }}
                            >
                                {inputProps => (
                                    <RadioSwitch
                                        tabIndex={1}
                                        leftLabel={t("global.fields.selection.yes")}
                                        leftValue="true"
                                        rightLabel={t("global.fields.selection.no")}
                                        rightValue="false"
                                        {...inputProps}
                                    />
                                )}
                            </RadioButtonInputGroup>
                            <InputGroup
                                label={t("loanform.additionalinfo.fields.salary.label")}
                                description={t("loanform.additionalinfo.fields.salary.description")}
                                fieldMessage={beenActived.includes("salary") && isNumberInputValid(true, salary, 0, t("loanform.additionalinfo.fields.salary.invalid"))}
                            >{inputProps => (
                                <>
                                    <InputWithUsability
                                        useseparatorformatter
                                        tabIndex={2}
                                        onBlur={() => setBeenActived([...beenActived, "salary"])}
                                        prefix="Kr"
                                        type="number"
                                        value={salary}
                                        name="salary"
                                        step={10000}
                                        min={0}
                                        onChange={e =>
                                            {if (e.target.value === "") {
                                                setSalary(undefined)
                                            } else {
                                                setSalary(Number(e.target.value))
                                            }}
                                        }
                                        {...inputProps}
                                    />
                                </>
                            )}</InputGroup>
                            <InputGroup
                                label={t("loanform.additionalinfo.fields.debt.label")}
                                description={t("loanform.additionalinfo.fields.debt.description")}
                                fieldMessage={beenActived.includes("debt") && isNumberInputValid(true, debt, 0, t("loanform.additionalinfo.fields.debt.invalid"))}
                            >{inputProps => (
                                <>
                                    <InputWithUsability
                                        useseparatorformatter
                                        tabIndex={3}
                                        onBlur={() => setBeenActived([...beenActived, "debt"])}
                                        prefix="Kr"
                                        type="number"
                                        value={debt}
                                        name="debt"
                                        step={10000}
                                        min={0}
                                        onChange={e =>
                                            {if (e.target.value === "") {
                                                setDebt(undefined)
                                            } else {
                                                setDebt(Number(e.target.value))
                                            }}
                                        }
                                        {...inputProps}
                                    />
                                </>
                            )}</InputGroup>
                            <InputGroup
                                label={t("loanform.additionalinfo.fields.kids.label")}
                                description={t("loanform.additionalinfo.fields.kids.description")}
                                fieldMessage={beenActived.includes("kids") && isNumberInputValid(true, kids, 0, t("loanform.additionalinfo.fields.kids.invalid"))}
                            >{inputProps => (
                                <>
                                    <InputWithUsability
                                        tabIndex={4}
                                        type="number"
                                        name="kids"
                                        onBlur={() => setBeenActived([...beenActived, "kids"])}
                                        value={kids}
                                        step={1}
                                        min={0}
                                        max={100}
                                        onChange={e =>
                                            {if (e.target.value === "") {
                                                setKids(undefined)
                                            } else {
                                                setKids(Number(e.target.value))
                                            }}
                                        }
                                        {...inputProps}
                                    />
                                </>
                            )}</InputGroup>
                            <InputGroup
                                label={t("loanform.additionalinfo.fields.domestic.label")}
                                description={t("loanform.additionalinfo.fields.domestic.description")}
                                fieldMessage={beenActived.includes("housing") && isDropdownInputValid(true,housing, 0, t("loanform.additionalinfo.fields.domestic.invalid"))}
                            >
                                <Dropdown
                                    onBlur={() => setBeenActived([...beenActived, "housing"])}
                                    tabIndex={5}
                                    value={housing}
                                    onChange={e =>
                                        setHousing(Number(e.target.value))
                                    }
                                >
                                    <option value={0} disabled>
                                        {t("loanform.additionalinfo.fields.domestic.select")}
                                    </option>
                                    <option value={1011}>{t("loanform.additionalinfo.fields.domestic.options.owner")}</option>
                                    <option value={1012}>{t("loanform.additionalinfo.fields.domestic.options.loaner")}</option>
                                    <option value={1013}>{t("loanform.additionalinfo.fields.domestic.options.other")}</option>
                                </Dropdown>
                            </InputGroup>
                            {housing == 1012?
                                <InputGroup
                                    label={t("loanform.additionalinfo.fields.rent.label")}
                                    description={t("loanform.additionalinfo.fields.rent.description")}
                                    fieldMessage={beenActived.includes("rent") && isNumberInputValid(true,rent, 0, t("loanform.additionalinfo.fields.rent.invalid"))}
                                >{inputProps => (
                                    <>
                                        <InputWithUsability
                                            useseparatorformatter
                                            tabIndex={6}
                                            prefix="kr"
                                            type="number"
                                            onBlur={() => setBeenActived([...beenActived, "rent"])}
                                            value={rent}
                                            name="rent"
                                            step={1000}
                                            onChange={e =>
                                                {if (e.target.value === "") {
                                                    setRent(undefined)
                                                } else {
                                                    setRent(Number(e.target.value))
                                                }}
                                            }
                                            {...inputProps}
                                        />
                                    </>
                                )}</InputGroup>
                            : null }
                            <InputGroup
                                label={t("loanform.additionalinfo.fields.domesticstatus.label")}
                                description={t("loanform.additionalinfo.fields.domesticstatus.description")}
                                fieldMessage={beenActived.includes("domestic") && isDropdownInputValid(true, domestic, 0, t("loanform.additionalinfo.fields.domesticstatus.invalid"))}
                            >
                                <Dropdown
                                    onBlur={() => setBeenActived([...beenActived, "domestic"])}
                                    value={domestic}
                                    name="domestic"
                                    tabIndex={7}
                                    onChange={(e) =>
                                        setDomestic(Number(e.target.value))
                                    }
                                >
                                    <option value={0} disabled>
                                        {t("loanform.additionalinfo.fields.domesticstatus.select")}
                                    </option>
                                    <option value={1021}>{t("loanform.additionalinfo.fields.domesticstatus.options.together")}</option>
                                    <option value={1022}>{t("loanform.additionalinfo.fields.domesticstatus.options.single")}</option>
                                    <option value={1023}>{t("loanform.additionalinfo.fields.domesticstatus.options.other")}</option>
                                </Dropdown>
                            </InputGroup>
                            { domestic == 1021 ?
                                <>
                                    <InputGroup
                                        label={t("loanform.additionalinfo.fields.houseincome.label")}
                                        description={t("loanform.additionalinfo.fields.houseincome.description")}
                                        fieldMessage={beenActived.includes("houseIncome") && isNumberInputValid(true, houseIncome, 0, t("loanform.additionalinfo.fields.houseincome.invalid"))}
                                    >{inputProps => (
                                        <>
                                            <InputWithUsability
                                                useseparatorformatter
                                                tabIndex={3}
                                                onBlur={() => setBeenActived([...beenActived, "houseIncome"])}
                                                prefix="Kr"
                                                type="number"
                                                value={houseIncome}
                                                name="houseIncome"
                                                step={10000}
                                                min={0}
                                                onChange={e =>
                                                    {if (e.target.value === "") {
                                                        setHouseIncome(undefined)
                                                    } else {
                                                        setHouseIncome(Number(e.target.value))
                                                    }}
                                                }
                                                {...inputProps}
                                            />
                                        </>
                                    )}</InputGroup>
                                    <InputGroup
                                        label={t("loanform.additionalinfo.fields.housedebt.label")}
                                        description={t("loanform.additionalinfo.fields.housedebt.description")}
                                        fieldMessage={beenActived.includes("houseDebt") && isNumberInputValid(true, houseDebt, 0, t("loanform.additionalinfo.fields.housedebt.invalid"))}
                                    >{inputProps => (
                                        <>
                                            <InputWithUsability
                                                useseparatorformatter
                                                tabIndex={3}
                                                onBlur={() => setBeenActived([...beenActived, "houseDebt"])}
                                                prefix="Kr"
                                                type="number"
                                                value={houseDebt}
                                                name="houseDebt"
                                                step={10000}
                                                min={0}
                                                onChange={e =>
                                                    {if (e.target.value === "") {
                                                        setHouseDebt(undefined)
                                                    } else {
                                                        setHouseDebt(Number(e.target.value))
                                                    }}
                                                }
                                                {...inputProps}
                                            />
                                        </>
                                    )}</InputGroup>
                                </>
                            : null }
                            <RadioButtonInputGroup
                                label={t("loanform.additionalinfo.fields.shareInformation.label")}
                                description={<div className="ffe-small-text">
                                    {t("loanform.additionalinfo.fields.shareInformation.description")}
                                    <span> </span>
                                    <span
                                        style={{
                                            color: "#008cbb",
                                            textDecoration: "underline",
                                            cursor: "pointer"
                                        }}
                                        onClick={() => setShowMoreShareInformation(!showMoreShareInformation)}
                                    >{t("loanform.additionalinfo.readmore")}</span>
                                    { showMoreShareInformation ?
                                        <div className="ffe-small-text">
                                            <p dangerouslySetInnerHTML={{__html: t("loanform.additionalinfo.fields.shareInformation.readmore").replaceAll("\n", "</br>")}}></p>
                                        </div>
                                    : null }
                                </div>}
                                fieldMessage={beenActived.includes("shareInformation") && isBooleanInputValid(true, shareInformation, undefined, t("loanform.additionalinfo.fields.shareInformation.invalid"))}
                                name="shareInformation"
                                onBlur={() => setBeenActived([...beenActived, "shareInformation"])}
                                selectedValue={shareInformation?.toString()}
                                onChange={e => {
                                    setShareInformation(e.target.value);
                                }}
                            >
                                {inputProps => (
                                    <RadioSwitch
                                        tabIndex={1}
                                        leftLabel={t("global.fields.selection.yes")}
                                        leftValue="6071"
                                        rightLabel={t("global.fields.selection.no")}
                                        rightValue="6072"
                                        {...inputProps}
                                    />
                                )}
                            </RadioButtonInputGroup>
                            <RadioButtonInputGroup
                                label={t("loanform.additionalinfo.fields.electronicCommunication.label")}
                                description={<div className="ffe-small-text">
                                    {t("loanform.additionalinfo.fields.electronicCommunication.description")}
                                    <span> </span>
                                    <span
                                        style={{
                                            color: "#008cbb",
                                            textDecoration: "underline",
                                            cursor: "pointer"
                                        }}
                                        onClick={() => setShowMoreElectronicCommunication(!showMoreElectronicCommunication)}
                                    >{t("loanform.additionalinfo.readmore")}</span>
                                    { showMoreElectronicCommunication ?
                                        <div className="ffe-small-text">
                                            <p dangerouslySetInnerHTML={{__html: t("loanform.additionalinfo.fields.electronicCommunication.readmore").replaceAll("\n", "</br>")}}></p>
                                        </div>
                                    : null }
                                </div>}
                                fieldMessage={beenActived.includes("electronicCommunication") && isBooleanInputValid(true, electronicCommunication, undefined, t("loanform.additionalinfo.fields.electronicCommunication.invalid"))}
                                name="electronicCommunication"
                                onBlur={() => setBeenActived([...beenActived, "electronicCommunication"])}
                                selectedValue={electronicCommunication?.toString()}
                                onChange={e => {
                                    setElectronicCommunication(e.target.value);
                                }}
                            >
                                {inputProps => (
                                    <RadioSwitch
                                        tabIndex={1}
                                        leftLabel={t("global.fields.selection.yes")}
                                        leftValue="6171"
                                        rightLabel={t("global.fields.selection.no")}
                                        rightValue="6172"
                                        {...inputProps}
                                    />
                                )}
                            </RadioButtonInputGroup>
                        </ContentCard>
                    }
                    
                    {formdata.IsCoBuyer || guid == "test" ?
                        <ContentCard 
                            open={true} 
                            disableClick={true}
                        >
                            <h1>{t("loanform.additionalinfo.co_title")}</h1>
                            <RadioButtonInputGroup
                                label={t("loanform.additionalinfo.fields.pep.label")}
                                description={t("loanform.additionalinfo.fields.pep.description")}
                                name="copep"
                                fieldMessage={beenActived.includes("copep") && isBooleanInputValid(true, coPep, undefined, t("loanform.additionalinfo.fields.pep.invalid"))}
                                onBlur={() => setBeenActived([...beenActived, "copep"])}
                                selectedValue={coPep?.toString()}
                                onChange={e => {
                                    setCoPep(e.target.value == "true");
                                }}
                            >
                                {inputProps => (
                                    <RadioSwitch
                                        tabIndex={8}
                                        leftLabel={t("global.fields.selection.yes")}
                                        leftValue="true"
                                        rightLabel={t("global.fields.selection.no")}
                                        rightValue="false"
                                        {...inputProps}
                                    />
                                )}
                            </RadioButtonInputGroup>
                            <InputGroup
                                label={t("loanform.additionalinfo.fields.cosalary.label")}
                                description={t("loanform.additionalinfo.fields.cosalary.description")}
                                fieldMessage={beenActived.includes("cosalary") && isNumberInputValid(true, coSalary, 0, t("loanform.additionalinfo.fields.cosalary.invalid"))}
                            >{inputProps => (
                                <>
                                    <InputWithUsability
                                        useseparatorformatter
                                        tabIndex={9}
                                        prefix="Kr"
                                        type="number"
                                        onBlur={() => setBeenActived([...beenActived, "cosalary"])}
                                        value={coSalary}
                                        name="cosalary"
                                        step={10000}
                                        min={0}
                                        onChange={e =>
                                            {if (e.target.value === "") {
                                                setCoSalary(undefined)
                                            } else {
                                                setCoSalary(Number(e.target.value))
                                            }}                     
                                        }
                                        {...inputProps}
                                    />
                                </>
                            )}</InputGroup>
                            <InputGroup
                                label={t("loanform.additionalinfo.fields.codebt.label")}
                                description={t("loanform.additionalinfo.fields.codebt.description")}
                                fieldMessage={beenActived.includes("codebt") && isNumberInputValid(true, coDebt, 0, t("loanform.additionalinfo.fields.codebt.invalid"))}
                            >{inputProps => (
                                <>
                                    <InputWithUsability
                                        useseparatorformatter
                                        tabIndex={10}
                                        prefix="Kr"
                                        onBlur={() => setBeenActived([...beenActived, "codebt"])}
                                        type="number"
                                        value={coDebt}
                                        name="codebt"
                                        step={10000}
                                        min={0}
                                        onChange={e =>
                                            {if (e.target.value === "") {
                                                setCoDebt(undefined)
                                            } else {
                                                setCoDebt(Number(e.target.value))
                                            }}
                                        }
                                        {...inputProps}
                                    />
                                </>
                            )}</InputGroup>
                            <InputGroup
                                label={t("loanform.additionalinfo.fields.cokids.label")}
                                description={t("loanform.additionalinfo.fields.cokids.description")}
                                fieldMessage={beenActived.includes("cokids") && isNumberInputValid(true, coKids, 0, t("loanform.additionalinfo.fields.cokids.invalid"))}
                            >{inputProps => (
                                <>
                                    <InputWithUsability
                                        tabIndex={11}
                                        type="number"
                                        name="cokids"
                                        onBlur={() => setBeenActived([...beenActived, "cokids"])}
                                        value={coKids}
                                        step={1}
                                        min={0}
                                        max={100}
                                        onChange={e =>
                                            {if (e.target.value === "") {
                                                setCoKids(undefined)
                                            } else {
                                                setCoKids(Number(e.target.value))
                                            }}

                                        }
                                        {...inputProps}
                                    />
                                </>
                            )}</InputGroup>
                            <InputGroup
                                label={t("loanform.additionalinfo.fields.cohousing.label")}
                                description={t("loanform.additionalinfo.fields.cohousing.description")}
                                fieldMessage={beenActived.includes("cohousing") && isDropdownInputValid(true, coHousing, 0, t("loanform.additionalinfo.fields.cohousing.invalid"))}
                            >
                                <Dropdown
                                    onBlur={() => setBeenActived([...beenActived, "cohousing"])}
                                    tabIndex={12}
                                    value={coHousing}
                                    onChange={e =>
                                        setCoHousing(Number(e.target.value))
                                    }
                                >
                                    <option value={0} disabled>
                                        {t("loanform.additionalinfo.fields.cohousing.select")}
                                    </option>
                                    <option value={1011}>{t("loanform.additionalinfo.fields.cohousing.options.owner")}</option>
                                    <option value={1012}>{t("loanform.additionalinfo.fields.cohousing.options.loaner")}</option>
                                    <option value={1013}>{t("loanform.additionalinfo.fields.cohousing.options.other")}</option>
                                </Dropdown>
                            </InputGroup>
                            {coHousing == 1012 ?
                                <InputGroup
                                    label={t("loanform.additionalinfo.fields.corent.label")}
                                    description={t("loanform.additionalinfo.fields.corent.description")}
                                    fieldMessage={beenActived.includes("corent") && isNumberInputValid(true, coRent, 0, t("loanform.additionalinfo.fields.corent.invalid"))}
                                >{inputProps => (
                                    <>
                                        <InputWithUsability
                                            useseparatorformatter
                                            tabIndex={13}
                                            prefix="kr"
                                            type="number"
                                            value={coRent}
                                            onBlur={() => setBeenActived([...beenActived, "corent"])}
                                            name="corent"
                                            step={1000}
                                            onChange={e =>
                                                {if (e.target.value === "") {
                                                    setCoRent(undefined)
                                                } else {
                                                    setCoRent(Number(e.target.value))
                                                }}
                                            }
                                            {...inputProps}
                                        />
                                    </>
                                )}</InputGroup>
                            : null }
                            <InputGroup
                                label={t("loanform.additionalinfo.fields.codomesticstatus.label")}
                                description={t("loanform.additionalinfo.fields.codomesticstatus.description")}
                                fieldMessage={beenActived.includes("codomestic") && isDropdownInputValid(true, coDomestic, 0, t("loanform.additionalinfo.fields.codomesticstatus.invalid"))}
                            >
                                <Dropdown
                                    onBlur={() => setBeenActived([...beenActived, "codomestic"])}
                                    value={coDomestic}
                                    tabIndex={14}
                                    onChange={(e) =>
                                        setCoDomestic(Number(e.target.value))
                                    }
                                >
                                    <option value={0} disabled>
                                        {t("loanform.additionalinfo.fields.codomesticstatus.select")}
                                    </option>
                                    <option value={1021}>{t("loanform.additionalinfo.fields.codomesticstatus.options.together")}</option>
                                    <option value={1022}>{t("loanform.additionalinfo.fields.codomesticstatus.options.single")}</option>
                                    <option value={1023}>{t("loanform.additionalinfo.fields.codomesticstatus.options.other")}</option>
                                </Dropdown>
                            </InputGroup>
                        </ContentCard>
                    : null}
                    <ContentCard 
                        title={t("loanform.additionalinfo.send_title")}
                        open={true} 
                        disableClick={true}
                    >
                        <ActionButton
                            onClick={() => {
                                setShowFeedback(true);
                                if (!invalid){
                                    sendInformation();
                                }
                                else{
                                    setBeenActived(["pep",
                                        "salary", 
                                        "debt", 
                                        "rent", 
                                        "kids", 
                                        "domestic", 
                                        "housing",
                                        "houseIncome",
                                        "houseDebt",
                                        "electronicCommunication",
                                        "shareInformation",
                                        "copep",
                                        "cosalary",
                                        "codebt",
                                        "corent",
                                        "codomestic",
                                        "cohousing"
                                    ])
                                }
                            }}
                        >{t("loanform.additionalinfo.send_btn")}</ActionButton>
                        &nbsp;
                        {feedbackMessages.length > 0 && showFeedback ?
                        feedbackMessages.map((message, index) => {
                            return <p className={styles.warning} key={index}>{message}</p>
                        })
                        : null}
                    </ContentCard>
                </>
                :
                    <div className={styles.notfound}>
                        <ContentCard open={true} disableClick={true}>
                            <p>{t("loanform.errorpage.schema_not_found")}</p>
                            <p>{t("loanform.errorpage.schema_not_found_contact")}</p>
                        </ContentCard>
                    </div>
                }
            </div>
        :
            <div className={styles.loading}>
                <p>Laster inn skjema ..</p>
            </div>
        }
    </>);
};


export default Loanform;